import React from 'react';
import { CheckIcon } from 'lucide-react';
import { addOns } from '../data/content';
import { HeroReel } from './HeroReel';
const included = ["A dedicated coach located in Austin, TX", "Sessions on video, scheduled around class and work shifts", "Actionable tools and feedback", 'Async messaging when something urgent comes up'];
export function Coaching() {
  return <section id="coaching" className="bg-pearl-50 py-16 dark:bg-slate-950 sm:py-20" data-id="element-44" data-mp="jv6okry2r5cf">
      <div className="mx-auto max-w-6xl px-5 sm:px-8" data-id="element-45" data-mp="3saqbzac2dtjk">
        <div className="grid gap-12 lg:grid-cols-2 lg:items-center lg:gap-16" data-id="element-46" data-mp="3naaxugjyki0j">
          <div className="relative order-last pb-10 lg:order-first" data-id="element-47" data-mp="53o86t1az8sj">
            <HeroReel data-id="element-48" data-mp="51jwvq12r7i8" />
          </div>

          <div data-id="element-49" data-mp="4k2icdl7t6y">
            <p className="text-xs font-semibold uppercase tracking-[0.16em] text-plum-500 dark:text-plum-300" data-id="element-50" data-mp="3s9n9bdk9kd">
              MEET YOUR COACH & UNDERSTAND THE PLAN
            </p>
            <h2 className="mt-3 font-display text-3xl font-semibold tracking-tight text-slate-900 dark:text-pearl-50 sm:text-4xl" style={{
            fontSize: "32px"
          }} data-id="element-51" data-mp="1bki8u8hds14h">
              One coach and a customized plan. 
            </h2>
            <p className="mt-4 text-lg leading-relaxed text-slate-600 dark:text-slate-300" data-id="element-52" data-mp="trzvkko2ek5">
              From early career to management, Emberly Johnston founded Early Edge Coaching after years of corporate campus recruiting and managing early talent programs. Through her passion and expertise, Emberly designs development plans that enable students to discover their personal brand and confidence. 
            </p>

            <ul className="mt-7 space-y-3" data-id="element-53" data-mp="3e854o6h2ddwq">
              {included.map(item => <li key={item} className="flex gap-3 text-slate-700 dark:text-slate-200" data-id="element-54" data-mp="3j7zus7t0lzgq">
                  <span className="mt-0.5 inline-flex h-5 w-5 flex-none items-center justify-center rounded-full bg-butter-200 text-butter-700 dark:bg-butter-500/30 dark:text-butter-300" data-id="element-55" data-mp="3o12lm86equt8">
                    <CheckIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-56" data-mp="2viyi28d5g25n" />
                  </span>
                  <span className="leading-relaxed" data-id="element-57" data-mp="2ni8z224khgbc">{item}</span>
                </li>)}
            </ul>

            <div className="mt-8 border-t border-slate-200 pt-6 dark:border-slate-800" data-id="element-58" data-mp="2jgxewc4gpnaj">
              <p className="text-sm font-semibold text-slate-800 dark:text-pearl-100" data-id="element-59" data-mp="2x826qs1l9bab">
                Or grab just one thing:
              </p>
              <ul className="mt-3 flex flex-wrap gap-2" data-id="element-60" data-mp="2sc3m9fjdsdf6">
                {addOns.map(addOn => <li key={addOn.name} className="rounded-full border border-slate-200 bg-white px-4 py-2 text-sm text-slate-700 dark:border-slate-700 dark:bg-slate-900 dark:text-slate-200" data-id="element-61" data-mp="24ky772l9lp5x">
                    {addOn.name}
                  </li>)}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>;
}